/**
 * Runtime env access. `__env.js` (regenerated by web/entrypoint.sh on each
 * container start, loaded beforeInteractive in _document) populates
 * `window.__env` before hydration, so browser reads always see live config.
 */
declare global {
    interface Window {
        __env?: Record<string, string | undefined>
    }
}

/**
 * Build-time values, read through LITERAL keys.
 *
 * `process.env[key]` with a computed key is not inlined by Next, so a flag that is not also in
 * `__env.js` reads as empty in a built image no matter how the container is configured. Naming
 * each key here keeps it statically bundled — the same shape as the desktop's `processEnv`.
 */
const buildEnv: Record<string, string | undefined> = {
    NEXT_PUBLIC_AGENTA_API_URL: process.env.NEXT_PUBLIC_AGENTA_API_URL,
    NEXT_PUBLIC_AGENTA_LICENSE: process.env.NEXT_PUBLIC_AGENTA_LICENSE,
    NEXT_PUBLIC_AGENT_OVERVIEW: process.env.NEXT_PUBLIC_AGENT_OVERVIEW,
    NEXT_PUBLIC_POSTHOG_API_KEY: process.env.NEXT_PUBLIC_POSTHOG_API_KEY,
    NEXT_PUBLIC_CRISP_WEBSITE_ID: process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID,
    NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY:
        process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY,
    NEXT_PUBLIC_AGENTA_TOOLS_ENABLED: process.env.NEXT_PUBLIC_AGENTA_TOOLS_ENABLED,
    NEXT_PUBLIC_AGENTA_BILLING_ENABLED: process.env.NEXT_PUBLIC_AGENTA_BILLING_ENABLED,
    NEXT_PUBLIC_AGENT_CHAT_STEER: process.env.NEXT_PUBLIC_AGENT_CHAT_STEER,
    NEXT_PUBLIC_SETTINGS_NESTED_NAV: process.env.NEXT_PUBLIC_SETTINGS_NESTED_NAV,
    NEXT_PUBLIC_AGENT_BROWSE_RAIL: process.env.NEXT_PUBLIC_AGENT_BROWSE_RAIL,
    NEXT_PUBLIC_AGENTA_ONBOARDING_FLOW_ENABLED:
        process.env.NEXT_PUBLIC_AGENTA_ONBOARDING_FLOW_ENABLED,
}

export function getEnv(key: string): string {
    if (typeof window !== "undefined" && window.__env?.[key] !== undefined) {
        return window.__env[key] ?? ""
    }
    // `__env.js` first (runtime config wins), then the build-time value.
    return buildEnv[key] ?? process.env[key] ?? ""
}

/** Gates the per-user onboarding redirect after sign-up. */
export const isOnboardingFlowEnabled = (): boolean =>
    getEnv("NEXT_PUBLIC_AGENTA_ONBOARDING_FLOW_ENABLED").toLowerCase() === "true"

export function getApiUrl(): string {
    return getEnv("NEXT_PUBLIC_AGENTA_API_URL")
}
